import { render, staticRenderFns } from "./InputTextStock.vue?vue&type=template&id=4a0dad6e&scoped=true&"
import script from "./InputTextStock.vue?vue&type=script&lang=js&"
export * from "./InputTextStock.vue?vue&type=script&lang=js&"
import style0 from "./InputTextStock.vue?vue&type=style&index=0&id=4a0dad6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0dad6e",
  null
  
)

export default component.exports